export const MAX_WIDTH = 1920;
export const MAX_HEIGHT = 1920;
export const IMAGE_JPEG_QUALITY = 0.8;
